import { Box, IconButton, Typography } from "@material-ui/core";
import { GetAppOutlined } from "@material-ui/icons";
import config from "config";
import Constants from "helpers/constants";
import { getItem } from "helpers/storage";
import { File } from "interfaces/file";
import moment from "moment";
import React, { Component } from "react";
import { CHAIN_ROLE } from "state/auth";
import reportView from "../assets/img/reports-view.svg";
import SmallLoader from "./SmallLoader";
interface ProjectFilesCardProps {
  files: any;
  isLoading?: boolean;
  id?:number
  history?:any
  roleId?:number
  project?:any
  userRole?:any
}

interface ProjectFilesCardState {
  minTimeElapsed: boolean;
}

class ProjectFilesCard extends Component<ProjectFilesCardProps, ProjectFilesCardState> {
  private loadingTimer: NodeJS.Timeout | null = null


  constructor(props: ProjectFilesCardProps) {
    super(props);
    this.state = {
      minTimeElapsed: false,
    };
  }

  componentDidMount() {
    // Set minTimeElapsed to true after 2 seconds
    this.loadingTimer = setTimeout(() => {
      this.setState({ minTimeElapsed: true });
    }, 6000);
  }

  componentWillUnmount() {
    if (this.loadingTimer) {
      clearTimeout(this.loadingTimer);
    }
  }

  public handleDownloadClick = (
    e: React.MouseEvent<HTMLButtonElement>,
    file: File
  ) => {
    return window.open(`${config.API_SERVICE_URL}/api/file/${file.id}`);

  };
  render() {
    const { files, isLoading ,history, id,roleId,project,userRole} = this.props;
    const { minTimeElapsed } = this.state;

    let Files = [];
    const chainPermissionString = getItem(CHAIN_ROLE);
    const chainPermission = JSON.parse(chainPermissionString || "[]");

    const permission = chainPermission;
    const RestrictedRole = [
        Constants.VIEWER_NO_PSA_ACCESS,
        Constants.CONTRIBUTER_NO_PSA_ACCESS
      ];
    const restrcitedUser = RestrictedRole.includes(permission.role)

    if(restrcitedUser){
      // Remove .psa files and stores files from files array
      const filteredFiles = files.filter(
        (file: any) =>
          !file.name.toLowerCase().endsWith(".psa") &&
          file.maptype !== "Store"
      );
      Files = filteredFiles;
    }else{
      // Remove stores files from files array
      Files = files.filter((file: any) =>file.maptype !== "Store");
    }

    // Show loader if isLoading is true OR if minimum time hasn't elapsed yet
    const showLoader = isLoading || !minTimeElapsed;
    const showReportsButton = project.reportAccess ||(userRole===Constants.AB_SYSTEM_ADMIN && project.automatedDataProcessing);
    const cardStyle: React.CSSProperties = {
      flex: "1 1 350px",
      display: "flex",
      flexDirection: "column",
      gap: "12px",
      height: "100%",
      minHeight: "100%",
    };

    const filesDetailsStyle:React.CSSProperties = {
      backgroundColor: "#FFD700",
      borderRadius: "16px",
      padding: "16px",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
      color: "#000",
      height: showReportsButton ? "82%" : "100%",
      overflowY:"hidden"
    }

    const titleStyle: React.CSSProperties = {
      fontSize: "14px",
      fontWeight: 600,
      color: "#000",
      marginBottom: "4px",
    };

    const fileHeaderStyle: React.CSSProperties = {
      display: "flex",
      justifyContent: "space-between",
      fontWeight: 600,
      fontSize: "12px",
      color: "#000",
      paddingBottom: "0px",
      borderBottom: "1px solid #000000",
      lineHeight: "15px",
    };

    const fileItemStyle: React.CSSProperties = {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "0px 0",
    };

    const fileNameStyle: React.CSSProperties = {
      flex: "1.8",
      fontSize: "12px",
      color: "#000",
      fontWeight: 400,
    };

    const uploadedByStyle: React.CSSProperties = {
      flex: "1.1",
      fontSize: "12px",
      color: "#000",
      fontWeight: 400,
    };

    const uploadDateStyle: React.CSSProperties = {
      flex: "1.1",
      fontSize: "12px",
      color: "#000",
      fontWeight: 400,
      textAlign: "right",
    };

    const downloadIconStyle: React.CSSProperties = {
      color: "#000",
      fontSize: "12px",
      marginLeft: "8px",
    };

    const filesCountStyle: React.CSSProperties = {
      fontSize: "12px",
      fontWeight: 600,
      color: "#555",
      textAlign: "left",
    };

    const projectSurveyButtonStyle2: React.CSSProperties = {
      textTransform: "none",
      background: "linear-gradient(180.26deg, #FFFFFF 61.03%, #E3BD21 153.87%)",
      color: "#000",
      padding: "11.5px 16px",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      gap: "10px",
      marginTop: "0px",
      border: "1px solid #E0E0E0",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
      borderRadius: "12px",
      fontSize: "12px",
      fontWeight: 400,
      width: "100%",
      whiteSpace: "nowrap",
    };
    const projectdetailStyle: React.CSSProperties = {
      backgroundColor: "#ffffff",
      borderRadius: "16px",
      padding: "16px",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
      display: "flex",
      flexDirection: "column",
      gap: "10px",
      background: "linear-gradient(128.26deg, #FFFFFF 61.03%, #E3BD21 153.87%)",
      height: "100%",
    };

    return (
      <div style={cardStyle}>
      <div style={filesDetailsStyle}>
        <Typography variant="h6" style={titleStyle}>
          Project Files Here
        </Typography>

        {showLoader ? (
          <Box display="flex" justifyContent="center" alignItems="center" height="200px">
            <SmallLoader />
          </Box>
        ) : !Files || Files.length === 0 ? (
          <Box display="flex" justifyContent="center" alignItems="center" height="200px">
            <Typography style={{ fontSize: "12px", color: "#333" }}>
              No files available.
            </Typography>
          </Box>
        ) : (
          <>
            <Box style={fileHeaderStyle}>
              <Typography style={{ flex: "2", fontSize: "12px" }}>File Name</Typography>
              <Typography style={{ flex: "1.2", fontSize: "12px" }}>Uploaded By</Typography>
              <Typography
                style={{
                  flex: "1.2",
                  fontSize: "12px",
                  // textAlign: "right",
                  whiteSpace: "nowrap",
                }}
              >
                Upload Date
              </Typography>
            </Box>

            <div style={{ maxHeight: "250px", overflowY: "auto" }}>
              {Files?.map((file: any, index: any) => (
                <div key={index} style={fileItemStyle}>
                  <Typography style={fileNameStyle}>{file.name}</Typography>

                  <Typography style={uploadedByStyle}>
                    {file.user_name ? file.user_name : "-"}
                  </Typography>

                  <Box display="flex" alignItems="center" whiteSpace="nowrap" style={uploadDateStyle}>
                    {file.created_at
                      ? moment(file.created_at).format("MM-DD-YYYY")
                      : "-"}
                    <IconButton
                      size="small"
                      style={{ padding: 0, marginLeft: 8 }}
                      onClick={(e) => this.handleDownloadClick(e, file)}
                    >
                      <GetAppOutlined style={downloadIconStyle} />
                    </IconButton>
                  </Box>
                </div>
              ))}

              <Typography
                style={{
                  fontSize: "12px",
                  fontWeight: 600,
                  color: "#555",
                  position: "sticky",
                  bottom: 0,
                  background: "#FFD700",
                  paddingTop: "6px",
                  paddingBottom: "6px",
                  marginTop: "10px",
                }}
              >
                {`${Files.length} FILE${Files.length !== 1 ? "S" : ""}`}
              </Typography>
            </div>
          </>
        )}
      </div>
        {showReportsButton && (
          <div>
            <button
              onClick={() => history.push(`/projects-new/${id}/${roleId}/reports/${id}`)}
              style={projectSurveyButtonStyle2}
            >
              <img src={reportView} alt="Store Reset Status" width="16" height="16" />
              View Reports
            </button>
          </div>
        )}

      </div>
    );
  }
}

export default ProjectFilesCard;
